module.exports = __webpack_public_path__ + "static/media/collapse_arrow.05a623b7.svg";